// extracted by mini-css-extract-plugin
module.exports = {"innerWrap":"loginPage_innerWrap__2q3av","loginForm":"loginPage_loginForm__18C1l"};